import type { AdminThemeConfig } from '@/types/admin-theme';
import { HITOWA_BRAND } from '../../../constants/brand';

/**
 * Hitowa site-admin theme.
 * Same BC-* brand tokens as the clinic portal -- see `constants/brand.ts`.
 */
export const hitowaAdminTheme: AdminThemeConfig = {
  adminType: 'site',
  siteType: 'hitowa',
  siteName: 'Hitowa 管理ポータル',

  // Admin Theme - Blue
  adminTheme: {
    name: 'Admin',
    displayName: 'Hitowa Admin',
    colors: {
      primary: HITOWA_BRAND.brand,
      primaryHover: HITOWA_BRAND.brandHover,
      primaryDark: HITOWA_BRAND.brandDeep,
      secondary: HITOWA_BRAND.brandDark,
      secondaryHover: HITOWA_BRAND.brandDeep,
      sidebarBg: HITOWA_BRAND.brand,
      sidebarText: '#ffffff',
      menuOpen: 'rgba(0, 0, 0, 0.1)',
      menuHover: 'rgba(0, 0, 0, 0.15)',
      menuActive: 'rgba(0, 0, 0, 0.25)',
      sectionHeader: HITOWA_BRAND.brand,
      sectionHeaderText: '#ffffff',
    },
    logoPath: '/images/hitowa/keilog_icon.png',
    sidebarWidth: 'w-60',
  },
};
